/**
 * Skeleton loader for GenericCrmList during config resolution.
 *
 * Displays a compact placeholder within the h-64 container while
 * the entity type configuration is being fetched.
 */

import {
  SkeletonLoader,
  SkeletonTableRow,
} from '@/lib/components/SkeletonLoader';

export function GenericCrmListSkeleton() {
  return (
    <div className='h-64 p-6' role='status' aria-label='Loading list'>
      {/* Header placeholder */}
      <div className='mb-4'>
        <SkeletonLoader width='200px' height='24px' />
      </div>

      {/* Compact table skeleton - 3 rows fit within h-64 container */}
      <table className='w-full'>
        <tbody>
          <SkeletonTableRow columns={3} />
          <SkeletonTableRow columns={3} />
          <SkeletonTableRow columns={3} />
        </tbody>
      </table>
    </div>
  );
}
